import BasicResource from '@/api/resource';

class ItokensResource extends BasicResource {
    constructor () {
        super('itokens');
    }

    revoke () {
        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}`,
        });
    }
}

export default new ItokensResource;
